export default __webpack_public_path__ + "img/rewards-redeemed-ce0920f6c2750790329e36bdd53c26a3.png";